import { render, staticRenderFns } from "./Brief.vue?vue&type=template&id=cb5c55b4&scoped=true&"
import script from "./Brief.vue?vue&type=script&lang=js&"
export * from "./Brief.vue?vue&type=script&lang=js&"
import style0 from "./Brief.vue?vue&type=style&index=0&id=cb5c55b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb5c55b4",
  null
  
)

export default component.exports